export var VMutationType;
(function (VMutationType) {
    VMutationType[VMutationType["AddNode"] = 1] = "AddNode";
    VMutationType[VMutationType["RemoveNode"] = 2] = "RemoveNode";
    VMutationType[VMutationType["ChangeAttributes"] = 3] = "ChangeAttributes";
    VMutationType[VMutationType["CharacterData"] = 4] = "CharacterData";
    VMutationType[VMutationType["Document"] = 10] = "Document";
    VMutationType[VMutationType["StyleSheetRule"] = 20] = "StyleSheetRule";
    VMutationType[VMutationType["StyleSheetAdopted"] = 21] = "StyleSheetAdopted";
})(VMutationType || (VMutationType = {}));
